import { LDProvider, type LDReactOptions } from 'launchdarkly-react-client-sdk';

import { CONFIG } from '../launch-darkly.config';
import { type BaseFeatureFlags } from '../launch-darkly.types';
import { log } from '../utils';
import { LaunchDarklyContextProvider } from './launch-darkly.context-provider';
import { type Props } from './launch-darkly.provider.types';

// ─────────────────────────────────────────────────────────────────────────────

export const LaunchDarklyProvider = <FeatureFlags extends BaseFeatureFlags>(
  props: Props<FeatureFlags>,
) => {
  const { Context, defaultFlags, webClientSideID, localOverrides, children } =
    props;

  // ─── No Client ID ────────────────────────────────────────────────────

  if (!webClientSideID) {
    log.warn(
      '`webClientSideID` is not provided, skipping LaunchDarkly provider',
    );

    return children;
  }

  // ─────────────────────────────────────────────────────────────────────

  return (
    <LDProvider
      clientSideID={webClientSideID}
      reactOptions={ReactOptions}
      timeout={CONFIG.INIT_TIMEOUT_IN_SECONDS}
    >
      <LaunchDarklyContextProvider
        Context={Context}
        defaultFlags={defaultFlags}
        localOverrides={localOverrides}
      >
        {children}
      </LaunchDarklyContextProvider>
    </LDProvider>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const ReactOptions: LDReactOptions = {
  useCamelCaseFlagKeys: false,
};
